import EventEmitter from 'shared/utils/eventEmitter';

export default new EventEmitter();
